 <section id="repairs-records">

  <div class="flex flex-col-reverse sm:flex-row gap-2 mb-8">

    <div class="flex-grow mb-2">
      <div>
        <nz-collapse>
          <nz-collapse-panel [nzHeader]="'Advanced Search'">
            <div class="flex flex-col lg:flex-row sm:justify-between xl:items-center gap-4">
              <div class="flex flex-col xl:flex-row xl:items-center gap-3 xl:gap-0">
                <nz-input-group nzSearch [nzAddOnAfter]="suffixIconSearchButton">
                  <input type="text" (keydown.enter)="search()" [(ngModel)]="searchText" nz-input placeholder="Search here"/>
                </nz-input-group>

                <ng-template #suffixIconSearchButton>
                  <button nz-button nzType="primary" nzSearch class="bg-[#6B6C6E] border-[#6B6C6E]" (click)="search()">
                    <span nz-icon nzType="search"></span>
                  </button>
                </ng-template>
                <nz-divider
                  class="hidden lg:block"
                  [nzType]="'vertical'"
                ></nz-divider>


              </div>

              <div>
                <button nz-button nzBlock class="outline-button" (click)="resetSearch()">
                  Reset Search
                </button>
              </div>

            </div>
          </nz-collapse-panel>
        </nz-collapse>
      </div>
    </div>

    <button *appHasAnyPrivilege="'REPAIR_RECORDS_CREATE'" nz-button nzType="primary" (click)="navigateNewRepair()">
      New Repair Record
    </button>
  </div>


  <div [ngClass]="loading ? 'hidden' : 'block'" class="table-card">
    <div class="table-obj">
      <nz-table
        #basicTable [nzData]="repairsData" [nzShowSizeChanger]="pageSize.length > 5"
        [nzPageSizeOptions]="pageSize.pageSizeOptions" [nzPageSize]="pageSize.pageSize"
        [nzPageIndex]="pageSize.pageIndex" [nzFrontPagination]="false" [nzTotal]="pageSize.length"
        (nzQueryParams)="onTableParamsChange($event)" [nzScroll]="{ x: 'auto', y: '550px' }" nzTableLayout="fixed"
        nzOuterBordered
      >
        <thead>
        <tr>
          <th>Repair No</th>
          <th>Breakdown Date</th>
          <th>Issue</th>
          <th>Repair Done By</th>
          <th>Repair Start Date</th>
          <th>Repair End Date</th>
          <th>Back to Fleet Date</th>
          <th>Actions</th>

        </tr>
        </thead>
        <tbody>

        <!--        Normal Repairs entry-->
        <tr *ngFor="let data of basicTable.data" class="align-baseline">
          <td style="white-space: nowrap; min-width: 150px">
            <a *appHasAnyPrivilege="'REPAIR_RECORDS_SINGLE_VIEW'" (click)="navigateToSingle(data._id)">{{data.repairId}}</a>
            <span *ngIf="!hasPermission('REPAIR_RECORDS_SINGLE_VIEW')">{{data.repairId}}</span>
          </td>
          <td style="white-space: nowrap; min-width: 200px">{{ data.breakdownDetails.breakdownDate | date:'yyyy-MM-dd' }}</td>
          <td style="white-space: nowrap; min-width: 200px">{{data.breakdownDetails.issueType}}</td>
          <td style="white-space: nowrap; min-width: 200px">{{data.breakdownDetails.repairDoneBy}}</td>
          <td
          style="white-space: nowrap; min-width: 200px">{{ data.repairInformation.repairStartDate ? (data.repairInformation.repairStartDate | date:'yyyy-MM-dd') : '-' }}</td>
          <td
          style="white-space: nowrap; min-width: 200px">{{ data.repairInformation.repairEndDate ? (data.repairInformation.repairEndDate | date:'yyyy-MM-dd') : '-' }}</td>
          <td
          style="white-space: nowrap; min-width: 200px">{{ data.repairInformation.backToFleetDate ? (data.repairInformation.backToFleetDate | date:'yyyy-MM-dd') : '-' }}</td>
          <td *appHasAnyPrivilege="'REPAIR_RECORDS_SINGLE_VIEW,REPAIR_RECORDS_DELETE,REPAIR_RECORDS_UPDATE'" style="white-space: nowrap;">
            <button *appHasAnyPrivilege="'REPAIR_RECORDS_UPDATE'" class="outline-button mr-3" nz-button nzType="default" (click)="editNavigate(this.data._id)">
              Edit
            </button>
            <button *appHasAnyPrivilege="'REPAIR_RECORDS_SINGLE_VIEW,REPAIR_RECORDS_DELETE'"
              class="outline-button more-dropdown"
              nz-button
              nz-dropdown
              [nzDropdownMenu]="menu"
              nzPlacement="bottomCenter"
            >
              <span nz-icon nzType="more" nzTheme="outline"></span>
            </button>
            <nz-dropdown-menu #menu="nzDropdownMenu">
              <ul nz-menu>
                <li *appHasAnyPrivilege="'REPAIR_RECORDS_SINGLE_VIEW'" nz-menu-item nz-popconfirm nz-button (click)="navigateToSingle(data._id)">View</li>
                <a *appHasAnyPrivilege="'REPAIR_RECORDS_DELETE'"
                  nz-popconfirm
                  nzPopconfirmTitle="Are you sure delete this Repair  Record?"
                  nzPopconfirmPlacement="bottom"
                  (nzOnConfirm)="deleteSupplier(this.data._id)"
                >
                  <li nz-menu-item nz-popconfirm nz-button nzDanger>Delete</li>
                </a>
              </ul>
            </nz-dropdown-menu>
          </td>
        </tr>

        </tbody>
      </nz-table>
    </div>
  </div>
  <div [ngClass]="loading ? 'block' : 'hidden'">
    <app-table-skeleton-template [columnData]="skeletonTableColumns" [showAdvanceSearch]="false"></app-table-skeleton-template>
  </div>
</section>
